/// <amd-module name="Widgets/SprintBurndownWidget/SprintBurndownSettings" />
import { TeamScope } from "WidgetCommon/ModernWidgetTypes/CommonConfigurationTypes";

export interface SprintBurndownSettings {
    /** Describes if the widget was configured in legacy mode. */
    isLegacy?: boolean;
    /**A singular team  */
    team: TeamScope;
}
